import Profile from "components/shared/Profile";
import type { FunctionComponent } from "react";
import AddReferredBy from "./AddReferredBy";
import usePartner from "./usePartner";

const Partner: FunctionComponent = function () {
  const { referrer } = usePartner();

  return (
    <Profile.Section title="Partner portal">
      <Profile.Property
        clickToCopy={false}
        label="Referred by"
        value={
          referrer ? (
            <div className="text-left">
              {referrer?.contact_info?.trading_name}
              <br />
              {referrer?.id}
            </div>
          ) : (
            <AddReferredBy />
          )
        }
      />
    </Profile.Section>
  );
};

export default Partner;
